import { recordApi } from '../../../../../../../../api';
import { Statuses } from '../../../../../../../../constants/statuses';
import { createMap } from '../../../../../../../../utils/arrayUtil';

export function v3MatchPoliciesToRequirements(policyTypes, policies, requirements, includeNotReceived = true) {
  const requirementPolicyTypeMap = createMap(requirements, 'insurancePolicyTypeId', true);
  const requirementPolicyTypePropertyMap = createMap(requirements, 'insurancePolicyTypePropertyId');
  const receivedPolicyTypeIds = [];

  const policiesWithRequirements = policies.filter(p => (!p.archivedAt && !p.deletedAt))
    .reduce((enhancedRequirements, policy) => {
      const policyTypeId = policy.insurancePolicyTypeId;
      const policyPropertyValueMap = createMap(policy.propertyValues, 'insurancePolicyTypePropertyId');

      receivedPolicyTypeIds.push(policyTypeId);

      const requirementPolicies = requirementPolicyTypeMap[policyTypeId] ?? null;

      const status = requirementPolicies ? requirementPolicies[0].status : Statuses.NotRequired;

      // // if a cached_status was missed, then update to the last user set status and let PINS recalculate
      // if (status === 'null' || !status) {
      //   status = requirementPolicies[0].requirementPolicyStatus;
      //
      //   recordApi.updateRequirementStatuses({
      //     recordId: requirementPolicies[0].insuranceRequirementId,
      //     policyId: policy.id,
      //     status,
      //     logActivity: false
      //   });
      // }

      const isLoading = policy?.isLoading || (requirementPolicies ? (requirementPolicies[0].isLoading || policy?.isLoading) : false);
      let sortOrder = requirementPolicies ? requirementPolicies[0].sortOrder : 0;

      if (status === Statuses.NotRequired) {
        sortOrder = 99;
      }

      const recordId = requirementPolicies ? requirementPolicies[0].insuranceRequirementId : null;

      // catch any requirements w/ not_received status
      // if (status === Statuses.NotReceived && !!policy.id) {
      //   status = Statuses.Pending;
      //
      //   recordApi.updateRequirementStatuses({
      //     recordId,
      //     policyId: policy.id,
      //     status: Statuses.Pending,
      //     logActivity: false
      //   });
      // }

      // property mapping
      const allProperties = policy.insurancePolicyType.properties.map(property => {
        const requirementProperty = requirementPolicyTypePropertyMap[property.id] ?? {};
        const { requiredValue: maxRequirement = null } = requirementProperty;

        if (policyPropertyValueMap[property.id]) {
          return {
            ...policyPropertyValueMap[property.id],
            maxRequirement
          };
        }

        return {
          insurancePolicyTypePropertyId: property.id,
          value: null,
          insurancePolicyTypeProperty: property,
          maxRequirement
        };
      });

      return [...enhancedRequirements, {
        ...policy,
        statusLoading: isLoading,
        propertyValues: allProperties,
        requirementStatus: status,
        sortOrder
      }];
    }, []);

  const notReceivedPolicies = !includeNotReceived
    ? []
    : Object.entries(requirementPolicyTypeMap)
      .map(([policyTypeId, requirement]) => ([parseInt(policyTypeId, 10), requirement]))
      .reduce((requirementsWithoutPolicies, [policyTypeId, requirementProperties]) => {
        if (receivedPolicyTypeIds.includes(policyTypeId)) {
          return requirementsWithoutPolicies;
        }

        const policyType = policyTypes.find(t => t.id === policyTypeId);

        const isLoading = requirementProperties.length ? requirementProperties.find(prop => prop.isLoading) : false;

        const requirementStatus = requirementProperties.length
          ? requirementProperties[0].status
          : Statuses.NotReceived;

        const sortOrder = requirementProperties.length ? requirementProperties[0].sortOrder : 0;

        const allProperties = requirementProperties.map(requirementProperty => ({
          insurancePolicyTypePropertyId: requirementProperty.insurancePolicyTypePropertyId,
          insurancePolicyTypeProperty: policyType.properties.find(p => p.id === requirementProperty.insurancePolicyTypePropertyId),
          value: null,
          maxRequirement: requirementProperty.requiredValue
        }));

        return [...requirementsWithoutPolicies, {
          insurancePolicyType: policyType,
          insurancePolicyTypeId: policyTypeId,
          statusLoading: isLoading,
          propertyValues: allProperties,
          requirementStatus,
          sortOrder
        }];
      }, []);

  const allPolicies = [...policiesWithRequirements, ...notReceivedPolicies];
  return allPolicies.sort((a, b) => {
    if (a.sortOrder === b.sortOrder) {
      // Use policy type ID as a tiebreaker for consistent ordering
      return a.insurancePolicyTypeId - b.insurancePolicyTypeId;
    }

    return a.sortOrder - b.sortOrder;
  });
}
